export default __webpack_public_path__ + "static/media/suitenupcias_3.e73a2efb.jpg";